import TagLine from "./Tagline";

const Heading = ({ className, title, text, tag }) => {
  return (
    <div
      className={`${className} max-w-[50rem] mx-auto mb-12 lg:mb-20 md:text-center`}
    >
      {tag && <TagLine className="mb-4 md:justify-center">{tag}</TagLine>}
      {title && <h2 className="h2" style={{ fontSize: "45px" }}>{title}</h2>}
      {text && <p className="body-2 mt-4 text-n-4" style={{ fontSize: "18px" }}>{text}</p>}
    </div>
  );
};

export default Heading;